<template>
  <div>
     <section class="page-banner" style="background-image: url(/static/img/kaoshizhongxin.png);">
            <div class="container">
                <div class="banner-tip">
                    <h2 class="banner-title">测评中心</h2>
                    <div class="bread-crumbs">
                      Test center
                    </div>
                </div>
            </div>
          </section>  
    <section class="course-area course-area4">
    <section>
      <div class="container section-heading">
          <div class="twotip">
              <img src="/static/img/apps_fill.png" class="courses-showing-icon"/><span class="courses-showing-text">我的测评</span>
            </div>
            <div class="sorting">
                      <p>测评科目:</p>
                      <select name="orderby" class="orderby" v-model="searchSub">
                          <option value="" selected="selected">所有科目</option>
                          <option :value="paperSub" v-for="(paperSub, index) in paperSubs" :key="index">{{ paperSub }}</option>
                      </select>
                  </div>
          <div class="search-box">
              <input type="search" v-model="searchWords" placeholder="输入关键字...">
              <button type="submit" @click="toPage(1)"><img src="/static/img/search-line.png" width="21" height="21"/></button>
          </div>
      </div>
     </section>
    <div class="course-content-wrapper">
      <div class="container" v-if="exams && exams.length > 0">
        <div class="row category-wrapper" >
          <div class="col-lg-6" v-for="(exam, index) in exams.slice(0, 2)" :key="index" >
              <div class="category-item">
                  <!-- <img :src="exam.picsrc ? `${global.remoteIp}/uploads/${exam.picsrc}` : '/static/images/mor.jpg'" alt=""> -->
                  <div class="img">
                    <div class="score">
                        {{ !exam.examAchieveMent ? '0' : exam.examAchieveMent.score }}
                    </div>
                    <div class="sums">
                      总分：{{ exam.totalscore }}
                    </div>
                    <h3 class="cat__title">{{ exam.title }}</h3>
                  </div>
                  <div class="category-content" > 
                      <div><span class="cat__meta_left" >测评科目：{{ exam.examinee.join(",") }}</span>
                      <span class="cat__meta_right">试卷类型：{{ exam.papertype == 'test' ? '模拟测评' : '竞聘测评' }}</span></div>
                      <div>
                      <span class="cat__meta_left">及格分数：{{ exam.passingscore }}分</span><span class="cat__meta_right">测评时长：{{ exam.duration }}分钟</span></div>
                      <div>
                      <span class="cat__meta_left">测评模式：{{ getExamTimes(exam.frepeat) }}</span><span class="cat__meta_right">到期时间：{{ exam.endtime }}</span></div>
                      <a href="javascript:void(0)" @click="enterExam(exam)" class="cat__link" v-if="!(exam.examState == 'end')">{{ getExamState(exam.examState) }}</a>
                      <p  class="cat__link_end" v-if="(exam.examState == 'end')">{{ getExamState(exam.examState) }}</p>
                  </div>
              </div>
          </div>
          </div>
      </div>
        <div class="container">
          <div class="pagination-wrap">
            <nav aria-label="Page navigation">
                <el-pagination
                background
                :page-size="2"
                :hide-on-single-page="intTotal <= 2"
                layout="prev, pager, next"
                @current-change="toPage"
                @prev-click="toPage"
                @next-click="toPage"
                :total="intTotal">
            </el-pagination>
            </nav>
          </div><!-- end pagination-wrap -->
        </div><!-- end container -->
    </div><!-- end course-content-wrapper -->
</section><!-- end courses-area -->
<el-dialog
        :visible.sync="faceVisible"
        :width="faceWidth"
        title="请保持脸部在取景框内"
        :show-close="false"
        center
        >
        <face-live-ex :visibleFlag="faceVisible" v-if="faceVisible" @VerfiyFailed = "faceVisible=false" :examId ="selExams._id" ref="faceBox" @chgWidth="chgWidth($event)" @VerfiyPass="verfiyPass($event)"/>
        <span slot="footer" class="dialog-footer">
            <el-button @click="faceVisible = false;" >取 消</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
import FaceLiveEx from "@/components/PublicComs/FaceLiveEx.vue";
export default {
  data() {
    return {
      global,
      intTotal: 20,
      intCurrent: 1,
      exams: [],
      plateId: "",
      searchType: "",
      paperSubs: [],
      searchWords: "",
      searchSub: "",
      faceWidth: "500px",
      faceVisible: false,
      selExams: {},
    };
  },
  // :to="global.isPhone()?`/exam/${exam._id}`:`/exampc/${exam._id}`"
  components: { FaceLiveEx },

  computed: {},
  watch: {
    searchType(newVal) {
      if (newVal) {
        this.toPage(0);
      }
    },
    searchSub(newVal){
      if (newVal) {
        this.toPage(0);
      }
    }
  },
  mounted() {
    if (this.global.isPhone()) {
      this.faceWidth = "90%";
    }
    if(this.$root.buytype==2)
    {
      this.intTotal=0;
      return;
    }
    this.$axios
      .get(`/api/students/testPapers?page=1&limit=6&sort=-istop,-createdAt`)
      .then((res) => {
        if (res.data) {
          this.exams = res.data.data;
          this.intTotal = res.data.total;
          // var temp = [...res.data.data, ...res.data.data, ...res.data.data];
          // this.intTotal = 3;
          // this.exams = temp;
        }
      });
      const isLogin = localStorage.eleTokenWrd001 ? true : false;
      if(isLogin) {
        this.$axios.get("/api/auth/me").then((res) => {
          let arrhasCourse = [];
          for (var i = 0; i <res.data.data.needexaminee.length; i++)
          {
            arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
          }
          this.paperSubs = arrhasCourse;
        });
      }else{
        this.$axios.get("/api/courseTypes?sort=-createdAt").then((res) => {
          if (res.data) {
           this.paperSubs = res.data.data;
          }
        });
      }
    
  },

  methods: {
    enterExam(exam) {
      if (exam.checkface&&this.$root.ischeckface) {
        this.faceVisible = true;
        this.selExams = exam;
      } else {
        this.selExams = exam;
        this.verfiyPass();
      }
    },
  verfiyPass() {
      if(this.selExams.isalone == true) {
        this.$router.push(
        this.global.isPhone()
          ? `/exam/${this.selExams._id}?_t=${Math.random()}`
          : `/examsigl/${this.selExams._id}?_t=${Math.random()}`
      );
      }else{
        this.$router.push(
        this.global.isPhone()
          ? `/exam/${this.selExams._id}?_t=${Math.random()}`
          : `/exampc/${this.selExams._id}?_t=${Math.random()}`
      );
      }
      
    },
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    setSearchSubs(searchSub) {
      this.searchSub = searchSub;
    },
    chgWidth(faceWidth) {
      this.faceWidth = faceWidth;
    },
    toPage(intcount) {
      if (intcount) this.intCurrent = intcount;
      var searchConditions = "";
      if (this.searchType) {
        searchConditions += "&papertype=" + this.searchType;
      }
      if (this.searchWords) {
        searchConditions += "&title=$regex:" + this.searchWords;
      }
      if (this.searchSub) {
        searchConditions += "&examinee=" + this.searchSub;
      }
      this.$axios
        .get(
          `/api/students/testPapers?page=${
            this.intCurrent
          }&limit=6&sort=-createdAt${searchConditions}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.exams = res.data.data;
            this.toTop();
          }
        });
    },
    dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
    getExamTimes(times) {
      switch (times) {
        case "0":
          return "不可补考";
        case "1":
          return "可补考一次";
        case "2":
          return "不限次数";
      }
    },
    getTimediff(starttime, endtime) {
      let start = new Date(starttime).getTime();
      let end = new Date(endtime).getTime();
      let time = end - start;
      //计算出相差天数
      var days = Math.floor(time / (24 * 3600 * 1000));

      //计算出小时数

      var leave1 = time % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000));
      //计算相差秒数
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      return `${hours} : ${minutes} : ${seconds}`;
    },
    NewDate(str) {
      if (!str) {
        return 0;
      }
      let arr = str.split(" ");
      let d = arr[0].split("-");
      let t = arr[1].split(":");
      var date = new Date();
      date.setUTCFullYear(d[0], d[1] - 1, d[2]);
      date.setUTCHours(t[0], t[1], t[2], 0);
      return date;
    },
    getExamState(state) {
      switch (state) {
        case "newStart":
          return "开始测评";
        case "resit":
          return "开始补考";
        case "repeatStart":
          return "重新测评";
        case "continue":
          return "继续测评";
        case "end":
          return "测评结束";
        default:
          return "开始测评";
      }
    },
    getExamState1(state) {
      switch (state) {
        case "newStart":
          return "正在测评";
        case "resit":
          return "正在测评";
        case "repeatStart":
          return "正在测评";
        case "continue":
          return "正在测评";
        case "end":
          return "测评完成";
        default:
          return "正在测评";
      }
    },
  },
};
</script>
<style scoped>

/deep/ .el-input__inner{
	height: 61px;
    line-height: 61px;
    width:368.8px;
    margin-top:15px;
    font-size: 16px;
}
/deep/ .el-input__suffix{
     margin-top:15px;
     height: 61px;
   
}
/deep/ .el-select .el-input .el-select__caret{
  color: #4282CAFF;
    font-size: 23px;
    font-weight: 600;
}
.el-icon-search{
        line-height: 61px;
    font-size: 21px;
    margin-right: 10px;
}
/deep/ .el-radio{
    margin-right: 41px;
    margin-left: 27px;
}
/deep/ .el-radio__label{
    font-size:16px;
    /* font-weight: 600; */
}
/deep/ .el-radio__inner{
        border: 2px solid #4485CCFF;
}

.course-wrapper{
	width: 1198px;
	height: 224px;
	background: #ffffff66;
	box-shadow: 0px 6px 17px 1px rgba(68, 133, 204, 0.27);
	border-radius: 5px;
	margin: auto;
	padding: 15px;
}
.category-item{
  margin-bottom: 15px;
}
.section-heading{
  display: flex;
  justify-content: space-between;
}
.twotip {
  padding-left:21px ;
  padding-right: 35px;
  height: 66px;
  background: #4462CF;
  box-shadow: 0px 10px 29px 0px rgba(68, 98, 207, 0.39);
  border-radius: 5px;
  display: flex;
  justify-content: start;
  align-items: center;
}
.search-box input{
  border: 0;
  padding-left:19px;
  padding-right: 12px;;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  width: 235px;
  height: 66px;
  background: #F5F7FF;
}
.search-box input::placeholder{
  color: #B7B7B7;
}
.search-box input[type="search"] {
  height: 66px;
}
.search-box button {
  background: #F5F7FF;
  border: 0;
  height: 66px;
  line-height: 66px;
}
.search-box img{
  margin-top: 0px;
  margin-left: 0px;
}
.search-box button{
  padding: 0 20px;
}
.sorting {
  margin-left: 270px;
  position: relative;
  display: flex;
  min-width: 320px;
  background: #F5F7FF;
  border-radius: 5px;
  height: 66px;
  padding-left: 22px;
}

.sorting p {
  font-size: 20px;
  color: #000000;
  line-height: 66px;
  font-weight: 600;
  margin: 0;
}

.sorting select {
  width: 145px;
  height: 100%;
  line-height: 66px;
  outline: none;
  margin: 0;
  border: 0;
  padding: 0 10px;
  color: #BFBEC0;
  font-size: 20px;
  font-weight: 400;
  -webkit-user-select: none;
  user-select: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
}

.sorting:after {
  content: "\33";
  font-family: 'ElegantIcons';
  display: inline-block;
  font-size: 20px;
  line-height: 66px;
  color: #000000;
  position: absolute;
  font-weight: 600;
  right: 18px;
  top: 0;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
/* two search */
.category-wrapper{
  margin-top: 37px;
    margin-bottom: 30px;
}
.col-lg-6{
  padding-right: 0;
}

.pagination-wrap>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
  width: 25px;
  min-width: 25px;
  height: 25px;
  background: #4462CF;
  border-radius: 50%;
  line-height: 25px;
}

.pagination-wrap>>>.el-pagination.is-background .el-pager li:not(.active):hover {
  color: #4462CF;
}

.pagination-wrap>>>.el-pagination.is-background .el-pager li {
  width: 25px;
  min-width: 25px;
  height: 25px;
  background: #EEEEEF;
  border-radius: 50%;
  line-height: 25px;
}

.pagination-wrap>>>.el-pagination.is-background .btn-prev {
  width: 25px;
  min-width: 25px;
  height: 25px;
  border: 1px solid #4462CF;
  border-radius: 50%;
  background: #fff;
  color: #4462CF;
}

.pagination-wrap>>>.el-pagination.is-background .btn-next {
  width: 25px;
  min-width: 25px;
  height: 25px;
  border: 1px solid #4462CF;
  border-radius: 50%;
  background: #fff;
  color: #4462CF;

}

.pagination-wrap>>>.el-pagination .btn-prev .el-icon {
  font-size: 16px;
}

.pagination-wrap>>>.el-pagination .btn-next .el-icon {
  font-size: 16px;
}

.pagination-wrap>>>.el-pagination {
  width: 1200px;
  text-align: right;
  height: 35px;
  padding-top: 4px;
  padding-bottom: 40px;
}

.pagination-wrap>>>.el-pager {
  height: 35px;
}

.pagination-wrap>>>.el-pager li {
  padding: 0;
  font-size: 14px;
  color: #666666;
}
</style>
